import { TextField, Typography, Snackbar } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import React, { useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router';
import SunEditor, { buttonList } from "suneditor-react";
import 'suneditor/dist/css/suneditor.min.css'; // Import Sun Editor's CSS File
import api from '../api';
import CloseImage from '../../assets/ic_close.png';
import ImageUploader from 'react-images-upload';
import { format } from 'date-fns';
import { useLocation } from 'react-router-dom';
import editProf from '../../assets/editProf.png';
import CustomDate from '../components/customDate';
import CustomTextField from '../components/customTextField';
import MuiAlert from '@material-ui/lab/Alert';

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}


export default function EditPromosi(props) {
    const editorRef = useRef();
    const location = useLocation()
    const history = useHistory()
    const [content, setContent] = useState("")
    const [title, setTitle] = useState("")
    const [id, setID] = useState("")
    const [validTo, setValidTo] = React.useState(null);
    const [validFrom, setValidFrom] = React.useState(new Date());
    const listPublish = [
        { value: 'Ya', id: 1 },
        { value: 'Tidak', id: 0 },
    ]
    const [isPublish, setPublish] = useState(listPublish[0])
    const [subTitle, setSubTitle] = useState("")
    const listTopPromo = [
        { value: 'Ya', id: 1 },
        { value: 'Tidak', id: 0 },
    ]
    const [isTopPromo, setTopPromo] = useState(listTopPromo[0])

    const forceUpdate = React.useReducer(bool => !bool)[1];
    const [visibleSeeDetailImage, setVisibleSeeDetailImage] = React.useState(false);
    const [visibleSeeDetailImage2, setVisibleSeeDetailImage2] = React.useState(false);

    const [visibleImage, setVisibleImage] = React.useState(false);
    const [pictures, setPicture] = useState([])
    const [photoList, setphotoList] = useState("")
    const [namaPicture, setnamaPicture] = useState([])

    const [visibleImage2, setVisibleImage2] = React.useState(false);
    const [pictures2, setPicture2] = useState([])
    const [photoHeader, setphotoHeader] = useState("")
    const [namaPicture2, setnamaPicture2] = useState([])

    const [errorTitle, setErrorTitle] = React.useState(false);
    const [texterrorTitle, setTextErrorTitle] = React.useState(null);
    const [errorFrom, setErrorFrom] = React.useState(false);
    const [texterrorFrom, setTextErrorFrom] = React.useState(null);
    const [errorTo, setErrorTo] = React.useState(false);
    const [texterrorTo, setTextErrorTo] = React.useState(null);
    const [errorPhotoList, setErrorPhotoList] = React.useState(false);
    const [texterrorPhotoList, setTextErrorPhotoList] = React.useState(null);
    const [errorPhotoHeader, setErrorPhotoHeader] = React.useState(false);
    const [texterrorPhotoHeader, setTextErrorPhotoHeader] = React.useState(null);

    const [messageAlert, setMessageAlert] = useState("")
    const [statusAlert, setStatusAlert] = useState("")
    const [openAlert, setOpenAlert] = useState(false);


    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlert(false)
    }

    useEffect(() => {
        // Get underlining core object here
        // Notice that useEffect is been used because you have to make sure the editor is rendered.
        console.log(editorRef.current.editor.core);
        getDetail()
    }, []);
    const handleImageUploadBefore = (files, info, uploadHandler) => {
        // uploadHandler is a function
        console.log(files, info, uploadHandler)
        try {
            ResizeImage(files, uploadHandler)
        } catch (err) {
            uploadHandler(err.toString())
        }
    }
    const handleImageUpload = (targetImgElement, index, state, imageInfo, remainingFilesCount) => {
        console.log(targetImgElement, index, state, imageInfo, remainingFilesCount)
    }

    const handleImageUploadError = (errorMessage, result) => {
        console.log(errorMessage, result)
    }

    const handleEditorChange = (value) => {
        console.log(value);

        setContent(value)
    }

    const handleDrop = (event) => {
        console.log(event); //Get the drop event
    }

    const handleBlur = (event, editorContents) => {
        console.log(event, editorContents); //Get the blur event
    }

    const imageUploadHandler = (xmlHttpRequest, info, core) => {
        console.log(xmlHttpRequest, info, core)
    }

    const ResizeImage = (files, uploadHandler) => {
        const uploadFile = files[0];
        const img = document.createElement('img');
        const canvas = document.createElement('canvas');
        const reader = new FileReader();

        reader.onload = function (e) {
            img.src = e.target.result
            img.onload = function () {
                let ctx = canvas.getContext("2d");
                ctx.drawImage(img, 0, 0);

                const MAX_WIDTH = 200;
                const MAX_HEIGHT = 100;
                let width = img.width;
                let height = img.height;

                if (width > height) {
                    if (width > MAX_WIDTH) {
                        height *= MAX_WIDTH / width;
                        width = MAX_WIDTH;
                    }
                } else {
                    if (height > MAX_HEIGHT) {
                        width *= MAX_HEIGHT / height;
                        height = MAX_HEIGHT;
                    }
                }

                canvas.width = width;
                canvas.height = height;

                ctx = canvas.getContext("2d");
                ctx.drawImage(img, 0, 0, width, height);

                canvas.toBlob(function (blob) {
                    uploadHandler([new File([blob], uploadFile.name)])
                }, uploadFile.type, 1);
            }
        }

        reader.readAsDataURL(uploadFile);
    }

    const getDetail = (cat) => {
        console.log(location);
        api.create().getDetailPromosi(location.state.id[6]).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    let data = response.data.data
                    setID(data.id)
                    setTitle(data.title)
                    setphotoList(data.list_image_url === null ? "" : data.list_image_url)
                    setphotoHeader(data.header_image_url === null ? "" : data.header_image_url)
                    setContent(data.content)
                    setValidTo(new Date(data.expired_date))
                    setValidFrom(new Date(data.effective_date))
                    setSubTitle(data.subtitle)
                    let idx = listPublish.findIndex((val) => val.id === data.is_publish)
                    if (idx > -1) {
                        setPublish(listPublish[idx])
                    }
                    let index = listTopPromo.findIndex((val) => val.id === data.is_top_promo)
                    if (index > -1) {
                        setTopPromo(listTopPromo[index])
                    }
                    forceUpdate()
                }
            }
        })
    }

    const handleSave = () => {

        let photoList = pictures[0]
        let photoHeader = pictures2[0]


        if (title === "") {
            setErrorTitle(true)
            setTextErrorTitle("judul wajib diisi")
        } else if (validFrom === null) {
            setErrorFrom(true)
            setTextErrorFrom("Valid From wajib diisi")
        } else if (validTo === null) {
            setErrorTo(true)
            setTextErrorTo("Valid To wajib diisi")
        } 
        else {
            let formData = new FormData()
            formData.append('promotion_id', id)
            formData.append('title', title)
            formData.append('subtitle', subTitle)
            if (photoList !== undefined) {
                formData.append('list_image_file', photoList)
            }
            if (photoHeader !== undefined) {
                formData.append('header_image_file', photoHeader)
            }
            formData.append('content', content)
            formData.append('expired_date', format(new Date(validTo), 'yyyy-MM-dd'))
            formData.append('effective_date', format(new Date(validFrom), 'yyyy-MM-dd'))
            formData.append('is_publish', isPublish.id)
            formData.append('is_top_promo', isTopPromo.id)
            console.log(...formData);

            api.create().updatePromosi(formData).then(response => {
                console.log(response);
                if (response.data) {
                    if (response.data.status === true) {
                        history.goBack()
                    } else {
                        if (response.data.data) {
                            if (response.data.data.content) {
                                setMessageAlert(response.data.data.content)
                                setStatusAlert('warning')
                                setOpenAlert(true)
                            }
                        }
                    }
                }
            })
        }

    }

    const onDrop = (pictureFiles, pictureDataURLs) => {
        console.log(pictureDataURLs);
        setphotoList(pictureDataURLs)
        setPicture(pictureFiles)
        setnamaPicture(pictureFiles.length > 0 ? pictureFiles[0].name : [])
    }
    const onDrop2 = (pictureFiles, pictureDataURLs) => {
        console.log(pictureDataURLs);
        setphotoHeader(pictureDataURLs)
        setPicture2(pictureFiles)
        setnamaPicture2(pictureFiles.length > 0 ? pictureFiles[0].name : [])
    }

    return (
        <div style={{ maxHeight: props.height - 80, width: '100%', overflow: 'scroll', padding: '20px 0px' }}>
            <Snackbar open={openAlert} autoHideDuration={3000} onClose={handleClose}>
                <Alert onClose={handleClose} severity={statusAlert}>
                    {messageAlert}
                </Alert>
            </Snackbar>
            <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between' }}>
                <div style={{ width: '100%' }}>
                    <Typography style={{ color: 'black', fontWeight: '500', fontSize: 20, fontFamily: 'Poppins' }}>Input Data Promosi</Typography>
                    <div style={{ display: 'flex', marginTop: 20, width: '40%', justifyContent: 'space-between' }}>
                        <Typography style={{ color: 'black', fontWeight: '300', fontSize: 16, fontFamily: 'Poppins', width: '20%' }}>Judul</Typography>
                        <Typography style={{ color: 'black', fontWeight: '300', fontSize: 16, fontFamily: 'Poppins' }}>:</Typography>
                        <div style={{ width: '60%', margin: 0 }}>
                            <CustomTextField
                                required={true}
                                error={errorTitle}
                                helperText={texterrorTitle}
                                placeholder={"input Judul"}
                                value={title}
                                onChange={(val) => {
                                    setTitle(val)
                                    setErrorTitle(false)
                                    setTextErrorTitle("")
                                    forceUpdate()
                                }}
                            />
                        </div>
                    </div>

                    <div style={{ display: 'flex', marginTop: 20, width: '40%', justifyContent: 'space-between' }}>
                        <Typography style={{ color: 'black', fontWeight: '300', fontSize: 16, fontFamily: 'Poppins', width: '20%' }}>Sub Title</Typography>
                        <Typography style={{ color: 'black', fontWeight: '300', fontSize: 16, fontFamily: 'Poppins' }}>:</Typography>
                        <div style={{ width: '60%', margin: 0 }}>
                            <CustomTextField
                                value={subTitle}
                                placeholder={"input Sub Judul"}
                                onChange={(val) => {
                                    setSubTitle(val)
                                    forceUpdate()
                                }}
                            />
                        </div>
                    </div>

                    <div style={{ display: 'flex', marginTop: 20, width: '40%', justifyContent: 'space-between' }}>
                        <Typography style={{ color: 'black', fontWeight: '300', fontSize: 16, fontFamily: 'Poppins', width: '20%' }}>Image List</Typography>
                        <Typography style={{ color: 'black', fontWeight: '300', fontSize: 16, fontFamily: 'Poppins' }}>:</Typography>
                        <TextField
                            style={{ width: '60%' }}
                            placeholder={"Image List"}
                            onClick={() => {
                                setVisibleSeeDetailImage(true)
                                // setPicture("")
                            }}
                            inputProps={{
                                style: {
                                    fontSize: 14,
                                }
                            }}
                            InputLabelProps={{
                                style: {
                                    fontSize: 14,
                                    color: '#7e8085',
                                }
                            }}
                            value={"Lihat Detail"}
                        />
                    </div>

                    <div style={{ display: 'flex', marginTop: 20, width: '40%', justifyContent: 'space-between' }}>
                        <Typography style={{ color: 'black', fontWeight: '300', fontSize: 16, fontFamily: 'Poppins', width: '20%' }}>Image Header</Typography>
                        <Typography style={{ color: 'black', fontWeight: '300', fontSize: 16, fontFamily: 'Poppins' }}>:</Typography>
                        <TextField
                            style={{ width: '60%' }}
                            placeholder={"Image Header"}
                            onClick={() => {
                                setVisibleSeeDetailImage2(true)
                                // setPicture2("")
                            }}
                            inputProps={{
                                style: {
                                    fontSize: 14,
                                }
                            }}
                            InputLabelProps={{
                                style: {
                                    fontSize: 14,
                                    color: '#7e8085',
                                }
                            }}
                            value={"Lihat Detail"}
                        />
                    </div>

                    <div style={{ display: 'flex', width: '40%', alignItems: 'center', justifyContent: 'space-between' }}>
                        <Typography style={{ color: 'black', fontWeight: '300', fontSize: 16, fontFamily: 'Poppins', width: '20%' }}>Valid From</Typography>
                        <Typography style={{ color: 'black', fontWeight: '300', fontSize: 16, fontFamily: 'Poppins' }}>:</Typography>
                        <div style={{ width: '60%', margin: 0 }}>
                            <CustomDate
                                value={validFrom}
                                required={true}
                                error={errorFrom}
                                helperText={texterrorFrom}
                                setValue={(date) => {
                                    setValidFrom(date)
                                    setErrorFrom(false)
                                    setTextErrorFrom("")
                                    forceUpdate()
                                }}
                            />
                        </div>
                    </div>

                    <div style={{ display: 'flex', width: '40%', alignItems: 'center', justifyContent: 'space-between' }}>
                        <Typography style={{ color: 'black', fontWeight: '300', fontSize: 16, fontFamily: 'Poppins', width: '20%' }}>Valid To</Typography>
                        <Typography style={{ color: 'black', fontWeight: '300', fontSize: 16, fontFamily: 'Poppins' }}>:</Typography>
                        <div style={{ width: '60%', margin: 0 }}>
                            <CustomDate
                                value={validTo}
                                minDate={validFrom}
                                required={true}
                                error={errorTo}
                                helperText={texterrorTo}
                                setValue={(date) => {
                                    setValidTo(date)
                                    setErrorTo(false)
                                    setTextErrorTo("")
                                    forceUpdate()
                                }}
                            />
                        </div>
                    </div>

                    <div style={{ display: 'flex', marginTop: 20, width: '40%', justifyContent: 'space-between' }}>
                        <Typography style={{ color: 'black', fontWeight: '300', fontSize: 16, fontFamily: 'Poppins', width: '20%' }}>Publish</Typography>
                        <Typography style={{ color: 'black', fontWeight: '300', fontSize: 16, fontFamily: 'Poppins' }}>:</Typography>
                        <Autocomplete
                            options={listPublish}
                            getOptionLabel={(option) => option.value}
                            disableClearable
                            style={{ width: '60%' }}
                            onChange={(event, newInputValue) => {
                                setPublish(newInputValue)
                                forceUpdate()
                            }}
                            renderInput={(params) =>
                                <TextField
                                    {...params}
                                    InputProps={{ ...params.InputProps, style: { fontSize: 13 } }}
                                    InputLabelProps={{ style: { color: '#7e8085' } }}
                                />
                            }
                            value={isPublish}
                        />
                    </div>

                    <div style={{ display: 'flex', marginTop: 20, width: '40%', justifyContent: 'space-between' }}>
                        <Typography style={{ color: 'black', fontWeight: '300', fontSize: 16, fontFamily: 'Poppins', width: '20%' }}>Top Promo</Typography>
                        <Typography style={{ color: 'black', fontWeight: '300', fontSize: 16, fontFamily: 'Poppins' }}>:</Typography>
                        <Autocomplete
                            options={listTopPromo}
                            getOptionLabel={(option) => option.value}
                            disableClearable
                            style={{ width: '60%' }}
                            onChange={(event, newInputValue) => {
                                setTopPromo(newInputValue)
                                forceUpdate()
                            }}
                            renderInput={(params) =>
                                <TextField
                                    {...params}
                                    InputProps={{ ...params.InputProps, style: { fontSize: 13 } }}
                                    InputLabelProps={{ style: { color: '#7e8085' } }}
                                />
                            }
                            value={isTopPromo}
                        />
                    </div>

                    <div style={{ marginTop: 20 }}>
                        <SunEditor
                            showToolbar={true}
                            enableToolbar={true}
                            ref={editorRef}
                            width={"100%"}
                            setOptions={{
                                width: '100%',
                                height: 200,
                                buttonList: [
                                    // default
                                    ['undo', 'redo'],
                                    ['font', 'fontSize', 'formatBlock'],
                                    ['paragraphStyle', 'blockquote'],
                                    ['fontColor', 'hiliteColor', 'textStyle'],
                                    ['bold', 'underline', 'italic', 'list', 'align'],
                                    ['table', 'link', 'image'],
                                    ['fullScreen']
                                ]
                                // buttonList: buttonList.formatting // Or Array of button list, eg. [['font', 'align'], ['image']]
                                // Other option
                            }}
                            onChange={handleEditorChange}
                            setContents={content}
                            onDrop={handleDrop}
                            imageUploadHandler={imageUploadHandler}
                            onBlur={handleBlur}
                            onImageUploadBefore={handleImageUploadBefore}
                            onImageUpload={handleImageUpload}
                            onImageUploadError={handleImageUploadError}
                        />
                    </div>
                </div>
            </div>
            <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end', marginTop: 20 }}>
                <div
                    style={{ backgroundColor: '#2a9c6c', width: 120, borderRadius: 20, padding: 5, display: 'flex', justifyContent: 'center', cursor: 'pointer' }}
                    onClick={() => {
                        handleSave()
                        // console.log(content);
                        // console.log(String(content).indexOf("*"));
                    }}>
                    <Typography style={{ color: 'white' }}>Simpan</Typography>
                </div>
            </div>
            {visibleImage && (
                <div className="App app-popup-show" style={{ zIndex: 5000 }}>
                    <div className="popup-content background-white border-radius" style={{ borderRadius: 8 }}>
                        <div className="popup-panel grid grid-2x main-color" style={{ height: 64, borderTopRightRadius: 8, borderTopLeftRadius: 8 }}>
                            <div className="col-1" style={{ maxWidth: "inherit", display: 'flex', alignItems: 'center' }}>
                                <div className="popup-title">
                                    <span style={{ color: 'black', fontSize: 18 }}>Upload File</span>
                                </div>
                            </div>
                            <div className="col-2 content-right" style={{ maxWidth: "inherit", alignSelf: 'center' }}>
                                <button
                                    type="button"
                                    className="btn btn-circle btn-white"
                                    onClick={() => {
                                        setVisibleImage(false)
                                        setPicture("")
                                    }}
                                >
                                    <img src={CloseImage} />
                                </button>
                            </div>
                        </div>
                        <ImageUploader
                            withIcon={true}
                            withPreview
                            buttonStyles={pictures.length > 0 ? { display: 'none' } : null}
                            buttonText={'Select Picture'}
                            onChange={onDrop}
                            imgExtension={['.jpg', '.gif', '.png', '.gif', '.jpeg']}
                            maxFileSize={1000000}
                            label={"Max file size: 1 Mb, accepted: jpg or png"}
                        />
                        {pictures.length > 0 ?
                            <div style={{ display: 'grid', margin: 20 }}>
                                <div style={{ justifySelf: 'center' }}>
                                    <span style={{ color: '#fff', padding: 20, paddingBottom: 10, paddingTop: 10, borderRadius: 15, cursor: 'pointer', backgroundColor: '#2a9c6c' }} onClick={() => setVisibleImage(false)}>Upload</span>
                                </div>
                            </div> : null
                        }
                    </div>
                </div>
            )}

            {visibleImage2 && (
                <div className="App app-popup-show" style={{ zIndex: 5000 }}>
                    <div className="popup-content background-white border-radius" style={{ borderRadius: 8 }}>
                        <div className="popup-panel grid grid-2x main-color" style={{ height: 64, borderTopRightRadius: 8, borderTopLeftRadius: 8 }}>
                            <div className="col-1" style={{ maxWidth: "inherit", display: 'flex', alignItems: 'center' }}>
                                <div className="popup-title">
                                    <span style={{ color: 'black', fontSize: 18 }}>Upload File</span>
                                </div>
                            </div>
                            <div className="col-2 content-right" style={{ maxWidth: "inherit", alignSelf: 'center' }}>
                                <button
                                    type="button"
                                    className="btn btn-circle btn-white"
                                    onClick={() => {
                                        setVisibleImage2(false)
                                        setPicture2("")
                                    }}
                                >
                                    <img src={CloseImage} />
                                </button>
                            </div>
                        </div>
                        <ImageUploader
                            withIcon={true}
                            withPreview
                            buttonStyles={pictures2.length > 0 ? { display: 'none' } : null}
                            buttonText={'Select Picture'}
                            onChange={onDrop2}
                            imgExtension={['.jpg', '.gif', '.png', '.gif', '.jpeg']}
                            maxFileSize={1000000}
                            label={"Max file size: 1 Mb, accepted: jpg or png"}
                        />
                        {pictures2.length > 0 ?
                            <div style={{ display: 'grid', margin: 20 }}>
                                <div style={{ justifySelf: 'center' }}>
                                    <span style={{ color: '#fff', padding: 20, paddingBottom: 10, paddingTop: 10, borderRadius: 15, cursor: 'pointer', backgroundColor: '#2a9c6c' }} onClick={() => setVisibleImage2(false)}>Upload</span>
                                </div>
                            </div> : null
                        }
                    </div>
                </div>
            )}

            {
                visibleSeeDetailImage ?
                    <div className="App app-popup-show">
                        <div className="popup-content background-white" style={{ borderRadius: 8, backgroundColor: 'white', height: '30vh', display: 'grid' }}>
                            <div style={{ margin: 'auto', width: 90, height: 90, backgroundColor: 'transparent', marginTop: 20, borderRadius: 50 }}>
                                <img style={{ width: 88, height: 90 }} src={photoList} />
                                <img src={editProf} style={{ width: 18.6, height: 18.6, marginTop: -45, cursor: 'pointer', backgroundColor: 'gray' }}
                                    onClick={(e) => {
                                        // setPicture("")
                                        // setUploadVisible(true)
                                        setVisibleImage(true)
                                        setPicture("")
                                    }}
                                />
                            </div>
                            <div>
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', margin: 'auto' }}>
                                <div onClick={() => setVisibleSeeDetailImage(false)} style={{ height: 32, width: 150, backgroundColor: '#2a9c6c', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer' }} >
                                    <Typography style={{ color: 'white', fontSize: 15, marginTop: 5 }}>Tutup</Typography>
                                </div>
                            </div>
                        </div>
                    </div>
                    : null
            }

            {
                visibleSeeDetailImage2 ?
                    <div className="App app-popup-show">
                        <div className="popup-content background-white" style={{ borderRadius: 8, backgroundColor: 'white', height: '30vh', display: 'grid' }}>
                            <div style={{ margin: 'auto', width: 90, height: 90, backgroundColor: 'transparent', marginTop: 20, borderRadius: 50 }}>
                                <img style={{ width: 88, height: 90 }} src={photoHeader} />
                                <img src={editProf} style={{ width: 18.6, height: 18.6, marginTop: -45, cursor: 'pointer', backgroundColor: 'gray' }}
                                    onClick={(e) => {
                                        // setPicture("")
                                        // setUploadVisible(true)
                                        setVisibleImage2(true)
                                        setPicture2("")
                                    }}
                                />
                            </div>
                            <div>
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', margin: 'auto' }}>
                                <div onClick={() => setVisibleSeeDetailImage2(false)} style={{ height: 32, width: 150, backgroundColor: '#2a9c6c', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer' }} >
                                    <Typography style={{ color: 'white', fontSize: 15, marginTop: 5 }}>Tutup</Typography>
                                </div>
                            </div>
                        </div>
                    </div>
                    : null
            }
        </div>
    )
}